import React, {Component} from 'react';
import {Link} from 'react-router-dom';

export default class Forbidden extends Component {
	render() {
		document.body.classList.add("pace-done");
		return (
			<section>
				<h1>403</h1>
				<Link to={process.env.APP_ROOT}>Go back</Link>
			</section>
		);
	}
}
